import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { ASSORTMENT_TOTALS_ROW } from "./pinned-row-renderers";

interface IProps extends ICellRendererParams {
    //
}

class DimensionValueRendererVanilla implements ICellRendererComp {
    declare eGui: HTMLElement;
    declare eValue: HTMLElement;

    private renderValue(params: IProps) {
        const { formatValue, value } = params;
        const formattedValue = formatValue(value);

        // Clear existing elements
        while (this.eValue.firstChild) {
            this.eValue.removeChild(this.eValue.firstChild);
        }

        const valueElement = document.createElement("span");
        valueElement.textContent = formattedValue;
        this.eValue.appendChild(valueElement);
    }

    private buildBaseElement(params: IProps) {
        // create the cell
        this.eGui = document.createElement("div");
        this.eGui.style.width = "100%";
        this.eGui.innerHTML = '<span class="value"></span>';
        if (params?.data?.totalType === ASSORTMENT_TOTALS_ROW) {
            this.eGui.innerHTML = '<span class="value totalsRow"></span>';
        }

        // get references to the elements we want
        this.eValue = this.eGui.querySelector(".value");
    }

    refresh(params: IProps): boolean {
        // set value into cell again
        this.renderValue(params);

        // return true to tell the grid we refreshed successfully
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(params: IProps) {
        this.buildBaseElement(params);

        // set value into cell
        this.renderValue(params);
    }
}

export { DimensionValueRendererVanilla };
